/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForCspServiceAccountMigration extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForCspServiceAccountMigration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForCspServiceAccountMigration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForCspServiceAccountMigration>): BackgroundJobPayloadForCspServiceAccountMigration {
        let obj = Object.assign(new BackgroundJobPayloadForCspServiceAccountMigration(), model);
        BackgroundJobPayloadForCspServiceAccountMigration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForCspServiceAccountMigration>): BackgroundJobPayloadForCspServiceAccountMigration {
        if (!model) return null;
        return BackgroundJobPayloadForCspServiceAccountMigration.newInstance(<BackgroundJobPayloadForCspServiceAccountMigration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForCspServiceAccountMigration) {
        if (!obj) return;

        models.BackgroundJobPayloadForCspServiceAccountMigration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForCspServiceAccountMigration): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForCspServiceAccountMigration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service account id of the customer's currently-resolved account at detection time
     */
    service_account_id: string;

    /**
     * The target service account ID represents the MPN to which this customer should be migrated.
     */
    target_service_account_id: string;

    /**
     * Indicates whether the migration is for the recent billing period and determines the source and target of the data movement.
     */
    is_recent_billing_period: boolean = false;

}
